<div class="container">
        <div class="map-container">
                <core-map [markers]=(markers)></core-map>
        </div>
</div>